import { useTranslation } from "react-i18next";

import { useCreate } from "@/hooks/queries";
import { useNavigateToRessource } from "@/hooks/useNavigateToRessource";

import OrganizationForm from "./OrganizationForm";

const Create = () => {
  const { t } = useTranslation();

  const mutation = useCreate("organizations");
  const saveButtonLabel = t("global:add");
  const initialValues = { name: "", description: "", address: "" };

  const onNavigateToOrganization = useNavigateToRessource(
    "/organizations/{{id}}",
    (response) => response.data.data.id
  );

  return (
    <OrganizationForm
      mutation={mutation}
      saveButtonLabel={saveButtonLabel}
      initialValues={initialValues}
      onMutate={onNavigateToOrganization}
    />
  );
};

export default Create;
